<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view v-if="isRouterAlive"/>
    </transition>
    <cube-popup :mask="false" type="prompt-popup" ref="layoutPop">{{msg}}</cube-popup>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data(){
    return {
      isRouterAlive: true,
      popup:null,
      msg:'再按一次退出程序',
    }
  },
  methods:{
    reload () {
          this.isRouterAlive = false
          this.$nextTick(function () {
            this.isRouterAlive = true
          })
        }
  },
  mounted(){
    this.popup = this.$refs.layoutPop
    document.addEventListener('plusready', () => {
      let first = false
      plus.key.addEventListener('backbutton', () => {
        // console.log(this.$router.history.current.name)
        let backRouter = this.$store.state.routerStore[this.$router.history.current.name]
        if(backRouter && backRouter.back){
          this.$router.push({name:backRouter.back})
        }else{
          if (!first) {
            first = true
            this.msg = '再按一次退出程序'
            this.popup.show()
            setTimeout(() => {
              this.popup.hide()
              first = false
            }, 2000)
          } else {
            plus.runtime.quit()
          }
        }
      })
      this.$router.beforeEach((to, from, next) => {
        if(plus.networkinfo.getCurrentType() == 1){
          this.msg = '网络异常'
          this.popup.show()
          setTimeout(() => {
            this.popup.hide()
          }, 2000)
        }else{
          next()
        }
      })
    })
    if (/Android/.test(navigator.appVersion)) {
      window.addEventListener('resize', function() {
        if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
          window.setTimeout(function() {
            document.activeElement.scrollIntoViewIfNeeded()
          }, 0)
        }
      })
    }
  }
}
</script>
